import { render, staticRenderFns } from "./TreatmentEdit.vue?vue&type=template&id=149aa2aa&scoped=true&"
import script from "./TreatmentEdit.vue?vue&type=script&lang=js&"
export * from "./TreatmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentEdit.vue?vue&type=style&index=0&id=149aa2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149aa2aa",
  null
  
)

export default component.exports